module.exports = __webpack_public_path__ + "static/media/productHistoryBanner.ac426a41.png";